module.exports = __webpack_public_path__ + "static/logo--orange-f267175552b349036c5e2c2bd8a18d3d.svg";